var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IntersectionType, PartialType } from '@nestjs/mapped-types';
import { ArrayNotEmpty, ArrayUnique, IsEmail, IsIn, IsInt, IsNumber, IsOptional, IsPhoneNumber, IsString, Length, Matches, Min, ValidateIf, } from 'class-validator';
import { WorkspaceDescriptorDto } from '../shared.js';
export const CONTRAGENT_ROLE_VALUES = [
    'advertiser',
    'agency',
    'ors',
    'publisher',
];
export const CONTRAGENT_TYPE_VALUES = [
    'ip',
    'juridical',
    'physical',
    'self_employed',
    'autonomous_non_profit_organization',
];
export class GetContragentsInputDto extends WorkspaceDescriptorDto {
    // @Transform(({ value }): unknown => (Array.isArray(value) ? value : [value]))
    roles;
}
__decorate([
    ArrayUnique(),
    ArrayNotEmpty(),
    IsIn(CONTRAGENT_ROLE_VALUES, { each: true }),
    __metadata("design:type", Array)
], GetContragentsInputDto.prototype, "roles", void 0);
class VkOrdContragentFields {
    inn;
    type;
    name;
    // @Transform(({ value }): unknown => (Array.isArray(value) ? value : [value]))
    roles;
    phone;
    rsUrl;
    bic;
    currentAccount;
    correspondentAccount;
    position;
    fullName;
    kpp;
    ogrn;
    link_id;
    registrationAddress;
    legalAddress;
    actualAddress;
    email;
    // Паспортные данные (только для физ. лиц)
    passportSeries;
    passportNumber;
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], VkOrdContragentFields.prototype, "inn", void 0);
__decorate([
    IsIn(CONTRAGENT_TYPE_VALUES),
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "type", void 0);
__decorate([
    Matches(/.+/),
    __metadata("design:type", String)
], VkOrdContragentFields.prototype, "name", void 0);
__decorate([
    ArrayUnique(),
    ArrayNotEmpty(),
    IsIn(CONTRAGENT_ROLE_VALUES, { each: true }),
    __metadata("design:type", Array)
], VkOrdContragentFields.prototype, "roles", void 0);
__decorate([
    IsPhoneNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional()
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    ,
    ValidateIf((o) => o.roles?.includes('ors')) // если рекламная сеть
    ,
    __metadata("design:type", String)
], VkOrdContragentFields.prototype, "rsUrl", void 0);
__decorate([
    IsString(),
    Length(9, 9),
    IsOptional(),
    ValidateIf((o) => Boolean(o.currentAccount && o.currentAccount.length > 0)) // если введен расчетный счет
    ,
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "bic", void 0);
__decorate([
    IsString(),
    Length(20, 20),
    IsOptional(),
    ValidateIf((o) => Boolean(o.bic && o.bic.length > 0)) // если введен БИК
    ,
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "currentAccount", void 0);
__decorate([
    IsString(),
    Length(20, 20),
    IsOptional(),
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "correspondentAccount", void 0);
__decorate([
    IsString(),
    IsOptional(),
    ValidateIf((o) => o.type === 'juridical') // если юридическое лицо
    ,
    __metadata("design:type", String)
], VkOrdContragentFields.prototype, "position", void 0);
__decorate([
    IsString(),
    IsOptional(),
    ValidateIf((o) => o.type === 'juridical') // если юридическое лицо
    ,
    __metadata("design:type", String)
], VkOrdContragentFields.prototype, "fullName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    ValidateIf((o) => o.type === 'juridical') // если юридическое лицо
    ,
    Length(9, 9),
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "kpp", void 0);
__decorate([
    IsString(),
    ValidateIf((o) => o.type === 'juridical' ||
        o.type === 'autonomous_non_profit_organization' ||
        o.type === 'ip') // если юридическое лицо, АНО или ИП
    ,
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "ogrn", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    ValidateIf((o) => 
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    o.roles?.includes('publisher')) // если распространитель
    ,
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], VkOrdContragentFields.prototype, "link_id", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "registrationAddress", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "legalAddress", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "actualAddress", void 0);
__decorate([
    IsEmail(),
    IsOptional(),
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "email", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Length(4, 4, { message: 'Серия паспорта должна состоять из 4 цифр' }),
    Matches(/^\d{4}$/, { message: 'Серия паспорта должна состоять из 4 цифр' }),
    ValidateIf((o) => o.type !== 'juridical' && o.type !== 'autonomous_non_profit_organization'),
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "passportSeries", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Length(6, 6, { message: 'Номер паспорта должен состоять из 6 цифр' }),
    Matches(/^\d{6}$/, { message: 'Номер паспорта должен состоять из 6 цифр' }),
    ValidateIf((o) => o.type !== 'juridical' && o.type !== 'autonomous_non_profit_organization'),
    __metadata("design:type", Object)
], VkOrdContragentFields.prototype, "passportNumber", void 0);
export class CreateVkOrdContragentInputDto extends IntersectionType(WorkspaceDescriptorDto, VkOrdContragentFields) {
}
export class UpdateVkOrdContragentInputDto extends IntersectionType(WorkspaceDescriptorDto, PartialType(VkOrdContragentFields)) {
}
//# sourceMappingURL=contragent.js.map